import Image from "next/image";

import {IconProps} from "@/types/img"

const Icon = ({
                  data = "",
                  class_name = "",
                  alt,
              }: IconProps) => {
    if (!data) return null;

    const isExternal =
        data.startsWith("http://") || data.startsWith("https://");

    const src = isExternal ? data : process.env.NEXT_PUBLIC_URL + `/assets/icons/${data}`;

    return (
        <Image
            src={src}
            alt={alt || data}
            className={`icon flex ${class_name}`}
            width={20}
            height={20}
            loading="lazy"
        />
    );
};

export default Icon;
